import { useEffect, useRef, useState } from "react"

import { WebApp } from "@/shared/telegram"

import { CloneLaunchScreen } from "./clone-launch-screen"

// iOS drops openTelegramLink calls made outside a tap, so the button is the reliable path there.
const FALLBACK_DELAY_MS = 1500

interface CloneRedirectScreenProps {
  url: string
  botHandle: string
}

export const CloneRedirectScreen: React.FC<CloneRedirectScreenProps> = ({ url, botHandle }) => {
  const [fallbackShown, setFallbackShown] = useState(false)
  const hasJumped = useRef(false)
  const jumpFailed = useRef(false)

  useEffect(() => {
    // AppProvider arms closing confirmation, which would pop a misleading prompt on this screen.
    WebApp.disableClosingConfirmation()
    if (hasJumped.current) return
    hasJumped.current = true
    try {
      WebApp.openTelegramLink(url)
    } catch (error: unknown) {
      console.warn("[CloneLaunchGate] Failed to open the main bot WebApp:", error)
      jumpFailed.current = true
    }
  }, [url])

  // A separate effect without the ref guard: StrictMode's simulated unmount clears this timer and the re-run restarts it.
  // It runs after the jump effect, so a failed jump shows the button without the wait.
  useEffect(() => {
    const timeoutId = window.setTimeout(
      () => {
        setFallbackShown(true)
      },
      jumpFailed.current ? 0 : FALLBACK_DELAY_MS
    )
    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [])

  const handleOpenSettings = () => {
    WebApp.openTelegramLink(url)
    WebApp.HapticFeedback.impactOccurred("light")
  }

  return (
    <CloneLaunchScreen
      variant={fallbackShown ? "fallback" : "redirecting"}
      botHandle={botHandle}
      onAction={handleOpenSettings}
    />
  )
}
